import EFPicture from 'elem/compCommon/EFPicture';
import PortableDesign from '@elem/SVGIcon/VanlifeRoadtrips/PortableDesign';
import PlugAndPlay from '@elem/SVGIcon/PowerBackup/PlugAndPlay';
import IP68 from '@elem/SVGIcon/VanlifeRoadtrips/IP68';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useLang } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const icons: any = [
        {
            icon: <PortableDesign />,
            text: t('secG_tag1'),
        },
        {
            icon: <PlugAndPlay className="color" />,
            text: t('secG_tag2'),
        },
        {
            icon: <IP68 />,
            text: t('secG_tag3'),
        },
    ];
    return (
        <div id="outdoor-recreation-G" className={`outdoor-recreation-G ${css['outdoor-recreation-G']}`}>
            <div className="img-box">
                <EFPicture
                    src={`/responsive/picture/outdoor-recreation/g.jpg`}
                    srcMobile={`/responsive/picture/outdoor-recreation/g_375.jpg`}
                    alt={t('secD_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secG_title')}</p>
                    <p className="desc">{t('secG_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
